const TRACEABILITY_MODULES = new Set([
  "trace", "pms", "pmcf", "capa", "ncr", "complaints", "recall", "fsca", "audit",
]);

export function getProjectSection(sectionParam, moduleParam) {
  if (sectionParam === "overview") return "overview";
  if (sectionParam === "classification") return "classification";
  if (sectionParam === "quality" || sectionParam === "traceability") return "traceability";
  if (sectionParam === "documents" || sectionParam === "regulatory") return "documents";
  if (sectionParam === "access" && moduleParam && moduleParam !== "none") {
    return getProjectSectionForModule(moduleParam);
  }
  return "overview";
}

export function getProjectModule(sectionParam, moduleParam) {
  if (sectionParam === "overview") return "";
  if (moduleParam === "none") return "";
  if (moduleParam) return moduleParam;
  if (sectionParam === "classification") return "classification";
  if (sectionParam === "documents") return "";
  if (sectionParam === "regulatory") return "preparation";
  if (sectionParam === "quality" || sectionParam === "traceability") return "trace";
  return "";
}

export function getProjectSectionForModule(moduleValue) {
  if (moduleValue === "classification") return "classification";
  return TRACEABILITY_MODULES.has(moduleValue) ? "traceability" : "documents";
}

export function getRegulatoryTargetId(tab) {
  return tab === "capa" ? "postmarket-capa" : `module-${tab}`;
}
